import MobileLayout from "@/components/one-to-one/MobileLayout.tsx";
import OneToOneHourSelect from "@/components/ui/OneToOneHourSelect.tsx";
import Warning from "@/components/ui/Warning.tsx";
import routes from "@/config/routes.ts";
import DashboardContentLayout from "@/layouts/DashboardContentLayout.tsx";
import useGlobals from "@/utils/hooks/useGlobals.ts";
import useOneToOne from "@/utils/hooks/useOneToOne.ts";
import HourPicker from "@edusogno/composites/hours";
import { Trans, useTranslation } from "react-i18next";
import Button from "@edusogno/primitives/button.js";
import { AllTutorsHourObj } from "../OneToOne";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function SelectHour() {
  const navigate = useNavigate();
  const { setGlobalState } = useGlobals();

  const {
    hour,
    // , date
    credits,
    setState,
    isFirstSession,
    selectedPreviousTutor,
  } = useOneToOne();
  // const date = dayjs();
  const { t } = useTranslation();

  const location = useLocation();

  const selectedDayEvents =
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    location?.state?.selectedDayEvents as AllTutorsHourObj[];

  const selectedPreviousTutorDayEvents =
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    location?.state?.selectedPreviousTutorDayEvents as string[];

  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  const previousTutorInfo = location?.state?.previousTutorInfo as {
    name: string;
    image: string;
    token: string;
  };

  // useEffect(() => {
  //   if (!date) {
  //     navigate(routes.one_to_one);
  //   }
  // }, [date]);

  useEffect(() => {
    setGlobalState("backgroundClass", "bg-brand-background");
  }, []);

  return (
    <DashboardContentLayout className={"until-lg:pb-0 until-lg:px-0"}>
      <MobileLayout>
        {isFirstSession || !previousTutorInfo ? (
          <HourPicker
            value={hour as string}
            // className={"[&_button]:flex-[1_1_129px] [&_button]:h-[35px] h-full"}
            hours={selectedDayEvents?.map((el) => el.hour)}
            openHours={selectedDayEvents?.map((el) => el.hour)}
            onValueChange={(e) => {
              setState("hour", e as string);

              const selectedDay = selectedDayEvents?.find(
                (el) => el.hour === e,
              );

              if (selectedDay) {
                setState("tutor", selectedDay?.tutorsAvailable[0].token);
              }
            }}
          />
        ) : (
          <div
            className={
              "w-full flex flex-col gap-2  h-fit !bg-white items-center "
            }
          >
            <OneToOneHourSelect
              value={hour as string}
              isPreviousTutor={selectedPreviousTutor}
              previousTutorInfo={previousTutorInfo}
              allList={selectedDayEvents}
              hours={selectedPreviousTutorDayEvents}
              openHours={selectedPreviousTutorDayEvents}
              onValueChange={(time, previousTutor, isPreviousTutor) => {
                const selectedDay = selectedDayEvents?.find(
                  (cal) => cal.hour === time,
                );

                if (isPreviousTutor) {
                  setState("selectedPreviousTutor", isPreviousTutor);
                } else {
                  setState("selectedPreviousTutor", false);

                  if (selectedDay)
                    setState("tutorList", selectedDay?.tutorsAvailable);
                }
                setState("hour", time as string);

                setState("tutor", previousTutor);
              }}
            />
          </div>
        )}
        <div className={"flex flex-col w-full gap-2 pb-2"}>
          <Warning
            text={
              <Trans
                i18nKey="one_to_one.warning_timezome"
                components={{
                  b: <b className="font-semibold" />,
                }}
              ></Trans>
            }
          />
          <div
            className={
              "flex justify-center flex-row items-center  w-full gap-x-2 "
            }
          >
            <Button size={"md"} color={"white"} onClick={() => navigate(-1)}>
              {t("btns.back")}
            </Button>
            <Button
              size={"md"}
              disabled={credits === 0 || !hour}
              onClick={() =>
                isFirstSession
                  ? navigate(routes.one_to_one_confirm, { replace: true })
                  : selectedPreviousTutor
                    ? navigate(routes.one_to_one_second_session, {
                      replace: true,
                    })
                    : navigate(routes.one_to_one_select_tutor)
              }
            >
              {t("btns.next")}
            </Button>
          </div>
        </div>
      </MobileLayout>
      {/*</div>*/}
    </DashboardContentLayout>
  );
}
